import { ApiConnector, DELETE, GET, POST } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/offices');
    const APIV2 = ApiConnector('/offices', true);
    return {
        OfficesList: async (data, query) => await API(GET, '', false, query).call(data),
        AddOffice: async data => await APIV2(POST, '').call(data),
        SingleOffice: async (data, query) => await API(GET, '/single', false, query).call(data),
        EditOffice: async (data, query) => await API(POST, '/edit', false, query).call(data),
        DeleteOffice: async query => await APIV2(DELETE, '', false, query).call(query),
    };
})();
